// src/components/Subscription/SubscriptionGuard.js
import React, { useEffect, useState } from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import SubscriptionPromo from './SubscriptionPromo';
import agthealthService from '../../services/agthealthService';

const SubscriptionGuard = ({ children }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasSubscription, setHasSubscription] = useState(false);
  const [isPro, setIsPro] = useState(false);
  const [subscriptionData, setSubscriptionData] = useState(null);

  useEffect(() => {
    const checkSubscription = async () => {
      try {
        // Verificar si el token ya tiene isPro
        const token = localStorage.getItem('agthealth_token');
        if (token) {
          const tokenData = JSON.parse(atob(token.split('.')[1]));
          if (tokenData.isPro === true) {
            setIsPro(true);
            setHasSubscription(true);
            setIsLoading(false);
            return;
          }
        }
  
        // Si no está en el token, verificar con el API
        const response = await agthealthService.getSubscriptionStatus();
  
        if (response.success) {
          setHasSubscription(response.data.hasSubscription);
          setIsPro(response.data.isPro);
          setSubscriptionData(response.data);
  
          // Si tiene suscripción activa pero el token no lo refleja, actualizar el token
          if (response.data.isPro === true && token) {
            const tokenData = JSON.parse(atob(token.split('.')[1]));
            if (tokenData.isPro !== true) {
              console.log('Actualizando token porque la API indica que el usuario es Pro');
              // Aquí podrías implementar una función para refrescar el token
              // O simplemente redirigir al login para obtener un nuevo token
            }
          }
        }
      } catch (error) {
        console.error('Error al verificar suscripción:', error);
      } finally {
        setIsLoading(false);
      }
    };
  
    checkSubscription();
  }, []);

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!isPro) {
    return <SubscriptionPromo onSuccess={() => setIsPro(true)} />;
  }

  return children;
};

export default SubscriptionGuard;